import img1 from "../images/about1.jpeg";
import img2 from "../images/about2.jpeg";
import SectionHeading from "./ui/SectionHeading";
import Reveal from "./ui/Reveal";

const About = () => {
  return (
    <section id="about" className="section-pad bg-[#eef5ea]">
      <SectionHeading eyebrow="Who We Are" title="About Us" />

      <div className="mx-auto grid max-w-6xl grid-cols-1 items-center gap-8 md:grid-cols-3">
        <Reveal>
          <div className="overflow-hidden rounded-2xl shadow-soft ring-1 ring-brand-gold/20">
            <img
              src={img1}
              alt="About Chalo Makkah Sharif"
              className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
        </Reveal>

        <Reveal delay={0.15} className="text-center">
          <p className="leading-relaxed text-gray-600">
            Chalo Makkah Sharif Tours &amp; Travels, owned by Haji Muhammad Ahmad
            Raza Qadri, has been serving pilgrims since 2005 with trusted Hajj
            and Umrah services. Our mission is to make every spiritual journey
            smooth, safe, and memorable. Alongside, we also offer tours across
            Pakistan — from the breathtaking mountains of Hunza and Skardu to
            the rich heritage of Punjab, Sindh, and Balochistan — ensuring every
            journey becomes an experience of a lifetime.
          </p>
          <div className="mt-8 flex justify-center gap-8">
            <div>
              <div className="text-3xl font-extrabold text-gradient">2005</div>
              <div className="text-xs text-gray-500">Serving Since</div>
            </div>
            <div>
              <div className="text-3xl font-extrabold text-gradient">700K+</div>
              <div className="text-xs text-gray-500">Pilgrims Served</div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <div className="overflow-hidden rounded-2xl shadow-soft ring-1 ring-brand-gold/20">
            <img
              src={img2}
              alt="About Chalo Makkah Sharif"
              className="h-full w-full object-cover transition-transform duration-500 hover:scale-105"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default About;
